import { getRouteStopCollFromAPI } from './routeStop';

const getDefaultRoute = () => {
  return {
    id: '',
    routeID: '',
    title: '',
    name: '',
    status: 'active',
    userId: 0,
    connectionType: 'product',
    productId: '',
    suitableFor: [],
    days: getDefaultDaysValues(),
    note: '',
    stops: [],
  };
};

const getDefaultStop = () => {
  return {
    index: undefined,
    providerId: '',
    provider: {},
    clueId: '',
    clue: {},
    clues: [],
    productId: '',
    product: {},
    action: '',
    itemId: '',
    item: {},
    variables: {},
  };
};

const getDefaultSparkStop = () => {
  return {
    index: undefined,
    clueId: '',
    clue: {},
    clues: [],
    productId: '',
    product: {},
    action: '',
    itemId: '',
    item: {},
    variables: {},
    spark : {},
    challenge : {},
    type : getStopType().SPARK_STOP
  };
};

const getRouteObjFromAPI = (routeFromAPI) => {
  let r = getDefaultRoute();
  r.name = routeFromAPI.name;
  r.note = routeFromAPI.note;
  r.routeStatus = routeFromAPI.isEnabled;
  r.productId = routeFromAPI.productId;
  r.owner = routeFromAPI.owner;
  r.stops = getRouteStopCollFromAPI(routeFromAPI.stops);
  r.id = routeFromAPI.id;

  return r;
};

  // get suitable days for the UI
  const getSuitableDays = (providersWhens) => {
    let days = getDefaultDaysValues();
    if (providersWhens && providersWhens.length > 0) {
      days.forEach((day) => {
        let found = providersWhens.filter((w) => {
          return w.value === day.name && !w.from.isEmpty && !w.to.isEmpty;
        });
        if (found && found.length > 0) day.value = true;
      });
    }
    return days;
  }

const getDefaultDietariesValues = () => {
  return [
    {
      name: 'vegan',
      alias: 'vegan',
      value: false,
    },
    {
      name: 'vegetarian',
      alias: 'vegetarian',
      value: false,
    },
    {
      name: 'glutenFree',
      alias: 'gluten free',
      value: false,
    },
  ];
};

const getDefaultDaysValues = () => {
  return [
    {
      name: 'Monday',
      alias: 'Mon',
      value: false,
    },
    {
      name: 'Tuesday',
      alias: 'Tues',
      value: false,
    },
    {
      name: 'Wednesday',
      alias: 'Wed',
      value: false,
    },
    {
      name: 'Thursday',
      alias: 'Thur',
      value: false,
    },
    {
      name: 'Friday',
      alias: 'Fri',
      value: false,
    },
    {
      name: 'Saturday',
      alias: 'Sat',
      value: false,
    },
    {
      name: 'Sunday',
      alias: 'Sun',
      value: false,
    },
  ];
};

// A duplicate of getStopType(). Remove it if nothing breaks on that side.

// const getRouteStopTypes = () => {
//   return [
//     'accomodation-stop',
//     'activity-stop',
//     'basket-pickup',
//     'basket-return',
//     'final-stop',
//     'insta-stop',
//     'picnic-stop',
//     'picnic-eat',
//     'sidedoor-stop',
//     'tasting-stop',
//   ];
// };

const getStopType = () => {
  return {
    ACCOMODATION_STOP: 'accomodation-stop',
    ACTIVITY_STOP: 'activity-stop',
    BASKET_PICKUP: 'basket-pickup',
    BASKET_RETURN: 'basket-return',
    FINAL_STOP: 'final-stop',
    INSTA_STOP: 'insta-stop',
    PICNIC_STOP: 'picnic-stop',
    PICNIC_EAT: 'picnic-eat',
    SIDEDOOR_STOP: 'sidedoor-stop',
    TASTING_STOP: 'tasting-stop',
    PICNIC_EXTRA: 'picnic-extra',
    SPARK_STOP: 'spark-stop',
    PAYMENT_ONLY: 'payment-only',
    // Seeded by the backend at HQ sync for a partner component, or one delivered by a single
    // provider item, so a planner has a cost row before anything is attached. A placeholder,
    // not fulfilment — don't treat its presence as the component being ready to deliver.
    COMPONENT_STOP: 'component-stop',
  };
};

export {
  getDefaultRoute,
  getDefaultDietariesValues,
  getDefaultDaysValues,
  getRouteObjFromAPI,
  getDefaultStop,
  getDefaultSparkStop,
  getStopType,
  getSuitableDays,
};
